import React, { useState } from "react";
import { Edit, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function ProfileSettings() {
  const [notifications, setNotifications] = useState({
    interestRequest: true,
    chat: true,
    profileViews: true,
    newProfileMatch: true,
  });

  const toggleNotification = (key) => {
    setNotifications((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-10">
      <div className="max-w-6xl mx-auto space-y-6">
        {/* Back Link */}
        <Link
          to="#"
          className="flex items-center text-base text-black font-medium mb-6"
        >
          <ArrowLeft className="h-6 w-6 mr-2" />
          Chat List
        </Link>

        {/* Profile Picture & Name */}
        <div className="flex flex-col items-center mb-8">
          <div className="w-36 h-36 rounded-full overflow-hidden bg-pink-200 mb-2">
            <img
              src="m_header.jpg"
              alt="Profile"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex items-center gap-2">
            <button className="text-gray-600">
              <img src="/edit.png" className="h-5 w-5" alt="Edit" />
            </button>
            <h2 className="text-xl font-medium">Ashley emyy</h2>
          </div>
        </div>

        <div className="max-w-5xl mx-auto">
          {/* Header */}
          <div className="flex items-center justify-between">
            <h1 className="text-xl text-[#66451C] font-semibold">Profile</h1>
          </div>

          {/* Profile Section */}
          <div className="space-y-6">
            {[
              {
                title: "Profile visible",
                description:
                  "You can set-up who can able to view your profile.",
                placeholder: "All users",
              },
              {
                title: "Who can send you Interest requests?",
                description:
                  "You can set-up who can able to make Interest request here.",
                placeholder: "All users",
              },
            ].map((item, index) => (
              <div className="space-y-1" key={index}>
                <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                  <div className="max-w-sm pt-1">
                    <h3 className="font-medium text-[#333333] mb-1">
                      {item.title}
                    </h3>
                    <p className="text-sm text-gray-500">{item.description}</p>
                  </div>
                  <input
                    type="text"
                    placeholder={item.placeholder}
                    className="w-full md:w-auto border border-gray-200 bg-[#F0F0F0] p-2 md:pr-40 rounded-md text-sm"
                  />
                </div>
              </div>
            ))}
          </div>

          {/* Account Section */}
          <div className="md:pt-10 pt-10">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-lg font-semibold text-gray-900">Account</h3>
              <button className="border border-[#607D8B] px-3 py-1 text-sm rounded-full text-[#607D8B] flex items-center gap-2">
                <Edit className="w-4 h-4" />
                Edit
              </button>
            </div>

            <div className="space-y-4 text-sm">
              {[
                { label: "Full name", value: "Anna Joslin", type: "text" },
                { label: "Mobile", value: "+91 9393 33533", type: "text" },
                {
                  label: "Email id",
                  value: "loremipsum@gmail.com",
                  type: "email",
                },
                { label: "Password", value: "password", type: "password" },
                { label: "Profile type", value: "Platinum", type: "text" },
              ].map(({ label, value, type }, i) => (
                <div
                  key={i}
                  className={`flex flex-col md:flex-row justify-between items-center border-b pb-2`}
                >
                  <label className="text-[#4A4A4A] w-full md:w-1/3 mb-2 md:mb-0">
                    {label}
                  </label>
                  <input
                    type={type}
                    defaultValue={value}
                    className="text-gray-900 font-medium w-full md:w-2/3 bg-transparent p-2 border-none focus:outline-none focus:ring-0"
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Notifications Section */}
          <div className="md:pt-10 pt-5">
            <h3 className="text-lg font-semibold text-[#333333] mb-6">
              Notifications
            </h3>

            <div className="space-y-6 text-sm">
              {[
                {
                  key: "interestRequest",
                  label: "Interest request",
                  desc: "Interest request email notifications",
                },
                { key: "chat", label: "Chat", desc: "New chat notifications" },
                {
                  key: "profileViews",
                  label: "Profile views",
                  desc: "If anyone views your profile, you get the notifications at the end of the day",
                },
                {
                  key: "newProfileMatch",
                  label: "New profile match",
                  desc: "You get the profile match emails",
                },
              ].map(({ key, label, desc }) => (
                <div
                  className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4"
                  key={key}
                >
                  <div className="flex-1">
                    <p className="font-medium text-[#333333] mb-1">{label}</p>
                    <p className="text-gray-500">{desc}</p>
                  </div>
                  <label className="inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={notifications[key]}
                      onChange={() => toggleNotification(key)}
                      className="sr-only"
                    />
                    <div
                      className={`w-10 h-5 rounded-full transition-colors ${
                        notifications[key] ? "bg-pink-500" : "bg-gray-300"
                      }`}
                    >
                      <div
                        className={`w-5 h-5 bg-white rounded-full shadow transform transition-transform duration-200 ${
                          notifications[key] ? "translate-x-5" : "translate-x-1"
                        }`}
                      ></div>
                    </div>
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
